var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useAppDispatch, useAppSelector } from "../../../../../stores";
import { PULSE_LOGOUT_EVENT, useLogoutMutation } from "../../services/logoutApi";
import Dialog from "../../../../../components/Dialog";
import PrimaryButton from "../../../../../components/PrimaryButton";
import { resetAuthSlice, setCurrentUser, setIsSessionExpired, setPulseAccountId, setSessionExpiredReason } from "../../../authSlice";
import { useLazyKeepSessionAliveQuery } from "../../../login/services/loginApi";
import { SESSION_EXPIRED_MESSAGE } from "../../../models/authModels";
import "./SessionExpiredDialog.css";
const SessionExpiredDialog = () => {
    const { currentUser, isSessionExpired, sessionExpiredReason } = useAppSelector(state => state.auth);
    const dispatch = useAppDispatch();
    const [logout] = useLogoutMutation();
    const [keepSessionAlive] = useLazyKeepSessionAliveQuery();
    useIdleTimer({
        // 15 min
        timeout: 15 * 60 * 1000,
        onIdle: () => __awaiter(void 0, void 0, void 0, function* () {
            if (currentUser !== null) {
                yield logout(null).unwrap();
                dispatch(setCurrentUser(null));
                dispatch(setPulseAccountId(null));
                dispatch(setIsSessionExpired(true));
                dispatch(setSessionExpiredReason(SESSION_EXPIRED_MESSAGE));
            }
        }),
        // 30 sec
        throttle: 30 * 1000,
        onAction: () => {
            if (currentUser) {
                keepSessionAlive(null);
            }
        }
    });
    useEffect(() => {
        const detectLogout = (e) => {
            if (e.key === PULSE_LOGOUT_EVENT && currentUser !== null) {
                dispatch(setIsSessionExpired(true));
                dispatch(setSessionExpiredReason(SESSION_EXPIRED_MESSAGE));
                dispatch(setCurrentUser(null));
                setTimeout(() => {
                    window.location.reload();
                }, 15 * 1000);
            }
        };
        window.addEventListener("storage", detectLogout);
        return () => {
            window.removeEventListener("storage", detectLogout);
        };
    }, [currentUser, dispatch]);
    const handleClose = () => {
        dispatch(resetAuthSlice());
        window.location.reload();
    };
    return (_jsx(Dialog, Object.assign({ visible: isSessionExpired, onHide: handleClose, header: "Session Expired", className: "session-expired-dialog", footer: (_jsx(PrimaryButton, { label: "OK", onClick: handleClose })) }, { children: sessionExpiredReason })));
};
export default SessionExpiredDialog;
